// import SiteDetailHeader from "./SiteDetailsHeader";

import {
  Card,
  CardHeader,
  Divider,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

const SiteDetail = ({
  clientCompany,
  clientEmail,
  clientFirstName,
  clientLastName,
  clientTelephone,
  entrepreneurCompany,
  entrepreneurCompanyNumber,
  entrepreneurEmail,
  entrepreneurFirstName,
  entrepreneurLastName,
  entrepreneurTelephone,
  siteConstructionYear,
  siteHousingType,
  siteMunicipality,
  siteNotes,
  siteNumber,
  sitePostalCode,
  siteStreet,

  user,
  createdAt,
  id,
}) => {
  return (
    <>
      {/* <SiteDetailHeader /> */}
      <Card elevation={0} style={{ marginBottom: "30px" }}>
        {/* <CardHeader action={<MoreMenu />} title="Recent Logs" /> */}
        <CardHeader title="Site informations" />
        <Divider />

        <Table sx={{ minWidth: 700 }}>
          <TableBody>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Street
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography>{siteStreet}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Street Number
                </Typography>
              </TableCell>
              <TableCell align="right">{siteNumber}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Postal Code
                </Typography>
              </TableCell>
              <TableCell align="right">{sitePostalCode}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Municipality
                </Typography>
              </TableCell>
              <TableCell align="right">{siteMunicipality}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Housing Type
                </Typography>
              </TableCell>
              <TableCell align="right">{siteHousingType}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ borderBottom: "none" }}>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Construction Date
                </Typography>
              </TableCell>
              <TableCell style={{ borderBottom: "none" }} align="right">
                {siteConstructionYear}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Card>
      <Card elevation={0} style={{ marginBottom: "30px" }}>
        {/* <CardHeader action={<MoreMenu />} title="Recent Logs" /> */}
        <CardHeader title="Client informations" />
        <Divider />

        <Table sx={{ minWidth: 700 }}>
          <TableBody>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  First Name
                </Typography>
              </TableCell>
              <TableCell align="right">{clientFirstName}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Last Name
                </Typography>
              </TableCell>
              <TableCell align="right">{clientLastName}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Company
                </Typography>
              </TableCell>
              <TableCell align="right">{clientCompany}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Email Address
                </Typography>
              </TableCell>
              <TableCell align="right">{clientEmail}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ borderBottom: "none" }}>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Phone Number
                </Typography>
              </TableCell>
              <TableCell style={{ borderBottom: "none" }} align="right">
                {clientTelephone}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Card>
      <Card elevation={0} style={{ marginBottom: "30px" }}>
        <CardHeader title="Entrepreneur informations" />
        <Divider />

        <Table sx={{ minWidth: 700 }}>
          <TableBody>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  First Name
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography>{entrepreneurFirstName}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Last Name
                </Typography>
              </TableCell>
              <TableCell align="right">{entrepreneurLastName}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Company
                </Typography>
              </TableCell>
              <TableCell align="right">{entrepreneurCompany}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Email Address
                </Typography>
              </TableCell>
              <TableCell align="right">{entrepreneurEmail}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ borderBottom: "none" }}>
                <Typography
                  color="textSecondary"
                  variant="caption"
                  fontSize="inherit"
                >
                  Phone Number
                </Typography>
              </TableCell>
              <TableCell style={{ borderBottom: "none" }} align="right">
                {entrepreneurTelephone}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Card>
    </>
  );
};

export default SiteDetail;
